import { atom } from 'jotai'

import { AppointmentSearchResult } from '../../__generated__/api'

export const initialReserveHistoryRestoredAtom = atom<boolean>(false)

export const bookedForSelfAtom = atom<boolean>(true)

export const preSelectedUserOmIdAtom = atom<number | undefined>(undefined)

export const selectedAppointmentDetailsAtom = atom<AppointmentSearchResult | undefined>(undefined)
